module.exports = "<nb-alert *ngFor=\"let message of messages; let i=index\" [status]=\"message.type\">{{message.message|translate}}\n</nb-alert>"